<template>
	<section class="hue-slider">
		<div class="row">
			<div class="col">
				Hue
				<span v-if="isGreyscale" class="u--small-06-opacity">(pick a color first)</span>
				<span v-else-if="unsaved" class="hue-slider__hint" @click="$emit('commit')">(auto-derived — click to set)</span>
			</div>
		</div>
		<div class="row hue-slider__controls">
			<div class="col">
				<input
					type="range"
					class="hue-slider__range"
					min="0"
					max="360"
					:disabled="isGreyscale"
					v-model.number="hue"
				/>
				<input
					type="number"
					class="hue-slider__value"
					min="0"
					max="360"
					:disabled="isGreyscale"
					v-model.number="hue"
				/>
			</div>
		</div>
	</section>
</template>

<script>
import util from '@/util'

export default {
	name: "HueSlider",
	props: {
		selectedColor: Object,
		// True when the stored color predates the hue system: the hue shown is derived
		// in memory but not yet persisted. Clicking the hint emits `commit` to set it.
		unsaved: Boolean
	},
	computed: {
		hue: {
			get() {
				return util.hueFromHsla(this.selectedColor && this.selectedColor.hsla)
			},
			// Rotate hue only, keeping saturation/lightness, and write the full derived
			// color back so we never depend on another component to backfill rgba/hex.
			set(value) {
				const derived = util.deriveColorFromHsla(util.withHue(this.selectedColor && this.selectedColor.hsla, value))
				Object.keys(derived).forEach(key => this.$set(this.selectedColor, key, derived[key]))
			}
		},
		// Rotating hue on a 0%-saturation color (the neutral default) does nothing
		// visible, so disable the control rather than let it read as broken.
		isGreyscale() {
			const parsed = util.parseHsla(this.selectedColor && this.selectedColor.hsla)
			return !parsed || parsed.s === 0
		}
	}
};
</script>

<style scoped>
	.hue-slider__controls { align-items: center; }

	.hue-slider__hint { font-size: 0.8em; opacity: 0.6; cursor: pointer; text-decoration: underline; }
	.hue-slider__hint:hover { opacity: 0.85; }

	.hue-slider__range {
		-webkit-appearance: none;
		appearance: none;
		width: 75%;
		height: 12px;
		border-radius: 6px;
		cursor: pointer;
		background: linear-gradient(to right,
			hsl(0, 100%, 50%), hsl(60, 100%, 50%), hsl(120, 100%, 50%),
			hsl(180, 100%, 50%), hsl(240, 100%, 50%), hsl(300, 100%, 50%), hsl(360, 100%, 50%));
	}
	.hue-slider__range:disabled { opacity: 0.35; cursor: not-allowed; }

	.hue-slider__range::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: #fff;
		border: 1px solid rgba(0, 0, 0, 0.4);
		cursor: pointer;
	}
	.hue-slider__range::-moz-range-thumb {
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background: #fff;
		border: 1px solid rgba(0, 0, 0, 0.4);
		cursor: pointer;
	}

	.hue-slider__value {
		width: 18%;
		margin-left: 8px;
		padding-left: 0;
		border: none;
		font-size: inherit;
		color: var(--preview-text-color);
		background: transparent;
	}
	.hue-slider__value:disabled { opacity: 0.35; }

	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
</style>
